module.exports = __webpack_public_path__ + "static/media/vid3.fb7113aa.mp4";